window.I18n.translations.en.categorySelect = {
  searchPlaceholder: 'Search...',
  findCategory: 'Find Category',
  addCategory: 'Add another category',
  optionalFindCategory: 'Choose a secondary category (optional)',
  categoryLabel: 'Category*'
};



// WEBPACK FOOTER //
// ./javascripts/translations/category_select/en.js